<template>
  <!-- Dialog Copy Idea -->
  <ib-dialog
    :visible="visible"
    :show-close="false"
    width="400px"
    @close="hideDialogLeaveIdea"
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/copy-note.svg')"
      :title="$t('dialogs.leaveIdea.title')"
    />
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :submit-btn-text="$t('dialogs.leaveIdea.yesImLeaving')"
        :cancel-btn-text="$t('dialogs.leaveIdea.noJustKidding')"
        :loading="loading"
        space-between-buttons
        @cancel="hideDialogLeaveIdea"
        @submit="confirm"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Leave Idea -->
</template>

<script>
export default {
  name: 'DialogLeaveIdea',

  props: {
    visible: {
      default: false,
      type: Boolean
    },

    hideDialogLeaveIdea: {
      type: Function,
      default: function () {}
    },

    confirm: {
      type: Function,
      default: function () {}
    }
  },

  data () {
    return {
      loading: false
    }
  }
}
</script>
